import PropTypes from 'prop-types'
import { Trash } from '@styled-icons/boxicons-solid'
import { formatDateTime, formatEmptyValue } from '../../../../utils/common'
import LinkWithStatus from '../../../common/LinkWithStatus'
import CheckBox from '../../../common/CheckBox'
import { useContext } from 'react'
import Tooltip from '../../../common/tooltip'
import { SalesCodeComplexityContext, SET_SELECTED_IDS } from './context/context'

const SalesCodeComplexityRow = (props) => {
  const [state, dispatch] = useContext(SalesCodeComplexityContext)

  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-1/12 items-center justify-center">
          <CheckBox
            checked={state?.selectedIds.includes(props.id)}
            onChange={(e) => {
              dispatch({ type: SET_SELECTED_IDS, data: props.id })
            }}
          />
        </div>
        <div className="flex w-3/12 items-center table_text">
          <Tooltip message={props?.harness}>
            <div>{formatEmptyValue(props.harness)}</div>
          </Tooltip>
        </div>
        <div className="flex w-3/12 pl-6 items-center table_text">
          <Tooltip message={props?.harness_type}>
            <div>{formatEmptyValue(props.harness_type)}</div>
          </Tooltip>
        </div>
        <div className="flex w-3/12 pl-6 items-center table_text">
          {formatDateTime(props.updated_at)}
        </div>
        <div className="flex w-2/12 pl-6 items-center justify-end">
          <div>
            <LinkWithStatus
              href={``}
              className="btn py-1 px-2"
              title="View Details"
              onClickFunc={() => {
                props.onShowDetails()
              }}
            />
          </div>

          <div>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2"
            >
              <Trash size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

SalesCodeComplexityRow.propTypes = {
  status: PropTypes.number,
  id: PropTypes.number,
  file_names: PropTypes.object,
  created_at: PropTypes.any,
  onShowDetails: PropTypes.func,
}

export default SalesCodeComplexityRow
